import { ActivateRegistrationFormInputs } from './types';

export const ACTIVATE_REGISTRATION_PATH = '/registration/verify-code';
export const ACTIVATE_REGISTRATION_ERRORS = {
  /** Code and/or email did not match. User may retry. */
  INVALID_CREDENTIALS: 'SSO11060',
  /** Too many failed attempts — code is suspended. Omega must issue a new one. */
  CODE_SUSPENDED: 'SSO11061',
  /** Code is past its 72-hour validity window. */
  CODE_EXPIRED: 'SSO11062',
  /** Code was already used to complete a registration. */
  CODE_ALREADY_USED: 'SSO11063',
} as const;
export const RESPONSE_INCLUDES_ATTEMPTS_REMAINING = false;
export const MAX_ACTIVATION_ATTEMPTS = 3;
/** Length of the code Omega sends. From the BRD: 6 digits. */
export const REGISTRATION_CODE_LENGTH = 6;
export const REGISTRATION_CODE_PATTERN = new RegExp(`^[0-9]{${REGISTRATION_CODE_LENGTH}}$`);
export const buildActivateRequest = (values: ActivateRegistrationFormInputs): Record<string, string> => ({
  registrationCode: values.registrationCode.trim(),
  email: values.email.trim(),
});
